export interface TouchPosition {
  x: number;
  y: number;
}

/**
 * Get the touch position
 */
export function getTouchPosition(event: TouchEvent | MouseEvent): TouchPosition {
  const touch: any = isTouchEvent(event) ? (event as TouchEvent).changedTouches[0] : event;

  return {
    x: touch.clientX,
    y: touch.clientY
  };
}

/**
 * Firefox doesn't know about TouchEvent and throws an error
 * Hence first checking the prop on window
 */
export function isTouchEvent(event: TouchEvent | MouseEvent): boolean {
  return window['TouchEvent'] && event instanceof TouchEvent;
}
